module.exports = __webpack_public_path__ + "static/iron-4a0260d4a112d749ff1dea0b7e574e15.jpg";